import React, { useEffect } from 'react';
import { createPortal } from 'react-dom';
import { motion } from 'framer-motion';
import { X } from '@phosphor-icons/react';
import { SnakExperience } from '../experience/SnakExperience';
interface LiveSnakWindowProps {
  onClose: () => void;
}

/** The live Snak, playing in a website-sized window above the page. */
export function LiveSnakWindow({
  onClose
}: LiveSnakWindowProps) {
  useEffect(() => {
    const onKey = (event: KeyboardEvent) => {
      if (event.key === 'Escape') onClose();
    };
    const previous = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    window.addEventListener('keydown', onKey);
    return () => {
      document.body.style.overflow = previous;
      window.removeEventListener('keydown', onKey);
    };
  }, [onClose]);
  return createPortal(<motion.div initial={{
    opacity: 0
  }} animate={{
    opacity: 1
  }} exit={{
    opacity: 0
  }} transition={{
    duration: 0.3
  }} className="fixed inset-0 z-50 flex items-center justify-center p-4 sm:p-8" data-id="element-119" data-mp="1bp2urae3miy4">
      <button type="button" aria-label="Close the Snak" onClick={onClose} className="absolute inset-0 cursor-default bg-[rgba(11,21,18,0.6)] focus:outline-none" data-id="element-120" data-mp="2jpse5c5p7a2g" />
      <motion.div role="dialog" aria-modal="true" aria-label="The Meet the Filteks Snak" initial={{
      opacity: 0,
      scale: 0.94,
      y: 16
    }} animate={{
      opacity: 1,
      scale: 1,
      y: 0
    }} exit={{
      opacity: 0,
      scale: 0.96,
      y: 10
    }} transition={{
      duration: 0.5,
      ease: [0.22, 1, 0.36, 1]
    }} className="relative flex h-[min(88vh,880px)] w-[min(760px,100%)] flex-col overflow-hidden rounded-[28px] bg-[#FBF7F0] shadow-[0_60px_120px_-40px_rgba(0,0,0,0.7)]" data-id="element-121" data-mp="29qkuk78dej6w">
        <div className="no-scrollbar h-full w-full overflow-y-auto overscroll-contain" data-id="element-122" data-mp="1m0qj9u3p92or">
          <SnakExperience data-id="element-123" data-mp="1i0f0kmuwdcfx" />
        </div>
        <button type="button" onClick={onClose} className="absolute right-4 top-4 z-20 inline-flex h-9 items-center gap-1.5 rounded-full bg-white/80 px-3.5 font-body text-[11px] font-medium text-background shadow-sm ring-1 ring-[rgba(1,51,43,0.12)] backdrop-blur-sm transition-colors hover:bg-white focus:outline-none focus-visible:ring-2 focus-visible:ring-primary" data-id="element-124" data-mp="1d1lieh4o0x9f">
          Close
          <X size={12} weight="bold" aria-hidden="true" data-id="element-125" data-mp="yghem88gs92h" />
        </button>
      </motion.div>
    </motion.div>, document.body);
}